import { useTranslation as useTranslationOriginal } from 'react-i18next';

/**
 * Type-safe wrapper for useTranslation that accepts namespace parameter
 * This is a workaround for TypeScript type resolution issues
 */
export function useTranslation<T extends string = string>(ns?: T) {
  // TypeScript type assertion - runtime behavior is identical
  return (useTranslationOriginal as any)(ns);
}

